import React from 'react'

import { Permitted } from 'components'

import { isEmpty } from 'lodash'

const PermittedByAssignmentRole = ({
  children,
  permittedRoles = [],
  unpermittedRoles = [],
  userRole,
  createdBySystem = false,
  someTags = [],
}) => {
  if (createdBySystem && !isEmpty(someTags)) {
    return <Permitted someTags={someTags}>{children}</Permitted>
  }

  if (!isEmpty(unpermittedRoles) && unpermittedRoles.includes(userRole)) {
    return null
  }

  if (isEmpty(unpermittedRoles) && permittedRoles.includes(userRole)) {
    return children
  }

  if (!isEmpty(unpermittedRoles) && !unpermittedRoles.includes(userRole)) {
    return children
  }

  return null
}

export default PermittedByAssignmentRole
